<template>
  <div>
    <DefaultNotificationAtendimento
    v-if="isOpen"
    @update-card="updateCard"
    @openCard="$emit('openCard', $event)"
    @close-notification="closeNotification"
    @toggle-today="toggleToday"
    @toggle-order="toggleOrder"
    @start-loading="startLoading"
    @stop-loading="stopLoading"
      :title="notification.title"
      :expand-text="notification.expandText"
      :notificationSwitch="true"
      :conversations="conversations"
      :viewedConversations="viewedConversations"
    />
  </div>
</template>

<script>
import DefaultNotificationAtendimento from '@/components/UI/notificacao/notificacaoAtendimentoPadrao.vue'
import NotificationsAtendimentoRepository from '@/shared/http/repositories/crm/notificationsatendimento.js'

export default {
  components: {
    DefaultNotificationAtendimento
  },
  mounted () {
    this.retrieveNotifications()
  },
  data () {
    return {
      notification:
      {
        title: 'Atendimento',
        expandText: 'Visualizados'
      },
      conversations: [],
      viewedConversations: [],
      data: [],
      isOpen: true,
      today: false,
      asc: true,
      isLoading: false
    }
  },
  methods: {
    closeNotification () {
      this.isOpen = false
    },
    formatDate (value) {
      if (value) {
        return this.moment(new Date(value)).tz('UTC').calendar()
      }
    },
    retrieveNotifications () {
      this.getViewed()
      this.startLoading()
      this.getNotViewed()
    },
    getViewed () {
      let filteredData = []
      let params
      NotificationsAtendimentoRepository.searchNotificationsUserViewdTrue(params)
        .then(response => {
          if (response.data && response.data.content) {
            this.data = response.data.content
            this.data.forEach(element => {
              let card = {}
              if (!element.isNumberStatus) {
                card = {
                  cardIcon: 'fas fa-headset',
                  cardIconText: this.formatDate(element.dataNotificiacao),
                  cardPersonPic: '',
                  cardTitle: element.conversation && element.conversation.name ? element.conversation.name.nome : 'Nome não disponível',
                  cardDescription: element.conversation && element.conversation.lastMessage ? element.conversation.lastMessage.text : 'Mensagem não disponível',
                  cardChecked: element.visualizado,
                  cardObj: element
                }
              } else {
                card = {
                  cardIcon: 'fas fa-headset',
                  cardIconText: this.formatDate(element.dataNotificiacao),
                  cardPersonPic: '',
                  cardTitle: 'Provedor desconectado',
                  cardDescription: `O provedor com número ${element.number} foi desconectado!`,
                  cardChecked: element.visualizado,
                  cardObj: element
                }
              }
              filteredData.push(card)
            })
            this.viewedConversations = filteredData
          }
        })
        .catch(this.onException)
        .finally(() => this.stopLoading())
    },

    getNotViewed () {
      let filteredData = []
      let params
      NotificationsAtendimentoRepository.searchNotificationsUserViewdFalse(params)
        .then(response => {
          if (response.data && response.data.content) {
            this.data = response.data.content

            this.data.forEach(element => {
              let card = {}
              if (!element.isNumberStatus) {
                card = {
                  cardIcon: 'fas fa-headset',
                  cardIconText: this.formatDate(element.dataNotificiacao),
                  cardPersonPic: '',
                  cardTitle: element.conversation && element.conversation.name ? element.conversation.name.nome : 'Nome não disponível',
                  cardDescription: element.conversation && element.conversation.lastMessage ? element.conversation.lastMessage.text : 'Mensagem não disponível',
                  cardChecked: element.visualizado,
                  cardObj: element
                }
              } else {
                card = {
                  cardIcon: 'fas fa-headset',
                  cardIconText: this.formatDate(element.dataNotificiacao),
                  cardPersonPic: '',
                  cardTitle: 'Provedor desconectado',
                  cardDescription: `O provedor com número ${element.number} foi desconectado!`,
                  cardChecked: element.visualizado,
                  cardObj: element
                }
              }

              filteredData.push(card)
            })
            this.conversations = filteredData
          } else {
            console.error('A resposta não contém a estrutura esperada:', response)
          }
        })
        .catch(this.onException)
        .finally(() => this.stopLoading())
    },
    updateCard (card) {
      this.retrieveNotifications()
    },
    toggleToday () {
      this.today = !this.today
      this.retrieveNotifications()
    },
    toggleOrder () {
      this.asc = !this.asc
      this.retrieveNotifications()
    },
    startLoading () {
      this.isLoading = true
    },
    stopLoading () {
      this.isLoading = false
    },
    onException (error) {
      console.error('Error:', error)
      this.stopLoading()
    }
  },
  emits: ['update-card', 'close-notification', 'toggle-today', 'toggle-order']
}
</script>



// WEBPACK FOOTER //
// src/components/UI/notificacao/Atendimento.vue